import { Directive } from '@angular/core';
import { Validator, AbstractControl, NG_VALIDATORS, ValidatorFn, ValidationErrors } from '@angular/forms';
import { AppConsts } from '@shared/AppConsts';

export function numericOnlyValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
        if (control.value == null)
            return null;
        var regex = new RegExp(AppConsts.regularExpressions.onlyNumerics);
        const restricted = !regex.test(control.value);
        return restricted ? { 'numericOnly': { value: control.value } } : null;
    };
}

@Directive({
    selector: '[numericOnly]',
    providers: [{ provide: NG_VALIDATORS, useExisting: NumericOnlyValidator, multi: true }]
})
export class NumericOnlyValidator implements Validator {
    validate(control: AbstractControl): ValidationErrors {
        return numericOnlyValidator()(control);
    }
}
